import ApiStatus from "./charts/apiStatus";
import RestartButton from "./restartButton";
import GeneralInfo from "./generalInfo";
import Performance from "./performance";
import ConnectionsList from "/app/src/components/status/connections/connectionsList";
import "./_status.scss";
import { useTranslation } from "react-i18next";
import Box from "../generic/components/box";
import GridWrapper from "../generic/gridWrapper";
import StatusHook from "./statusHook";
import ConnectionStatusCard from "./connectionStatusCard";
import { Divider } from "@heroui/react";
import { useContext } from "react";
import NavigationMenuContext from "/app/src/contexts/NavigationMenuContext";
import { useConnections } from "../../contexts/ConnectionsStatusContext";

/**
 * Component for displaying status page
 * @returns JSX.Element
 */
export default function StatusPage() {
  const { t } = useTranslation();
  const navigationMenu = useContext(NavigationMenuContext);
  const { webServices, powerPick } = useConnections();
  const { powerPickMSSQL, powerPickWebServices } = StatusHook();

  return (
    <>
      <div
        className={`-mt-[20px] ${navigationMenu === "1" ? "-mx-[16px]" : "-mx-[25px]"} h-20 px-8 bg-white flex justify-between items-center border-b border-gray-200`}
      >
        <h1 className="text-xl font-normal m-0">{t("translation:status")}</h1>
        <RestartButton />
      </div>
      <div className="px-4 mt-8 max-w-[1808px] mx-auto">
        <Box>
          <h3 className="font-archivo text-lg">
            {t("translation:connections")}
          </h3>
          <Divider className="mb-6" />
          <ConnectionsList />
        </Box>

        <GridWrapper columns={1}>
          <div className="col-span-full">
            <ApiStatus />
          </div>
        </GridWrapper>

        <GridWrapper responsive={{ sm: 1, md: 2, lg: 2 }} columns={2}>
          <ConnectionStatusCard
            connectionName={t("translation:power_pick_database")}
            data={powerPickMSSQL}
            isConnected={powerPick?.status}
          />
          <ConnectionStatusCard
            connectionName={t("translation:power_pick_web_services")}
            data={powerPickWebServices}
            isConnected={webServices?.status}
          />
        </GridWrapper>

        <GridWrapper responsive={{ sm: 1, md: 2, lg: 2 }} columns={2}>
          <GeneralInfo />
          <Performance />
        </GridWrapper>
      </div>
    </>
  );
}
